module.exports = __webpack_public_path__ + "static/media/linkedinlogo.9c372ea9.png";